import { createLogger, serializeError } from 'logging';
// TODO: This component should be moved to the design system
import { JSX } from 'react';

const logger = createLogger('SuccessBox');

interface SuccessBoxProps {
    message?: string;
    onDismiss?: () => void;
    className?: string;
}

export default function SuccessBox({ message, onDismiss, className = '' }: SuccessBoxProps): JSX.Element | null {
    if (!message) {
        return null;
    }

    const handleDismiss = () => {
        if (onDismiss) {
            try {
                onDismiss();
            } catch (error) {
                logger.error({ error: serializeError(error) }, 'Error in onDismiss handler');
            }
        }
    };

    return (
        <div className={`bg-green-50 p-4 py-6 rounded-sm border-l-8 border-green-600 ${className}`}>
            <div className="flex">
                <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                        />
                    </svg>
                </div>
                <div className="ml-3 flex-1">
                    <div className="text-sm text-green-600 whitespace-normal leading-6">{message}</div>
                </div>
                {onDismiss && (
                    <button
                        type="button"
                        onClick={handleDismiss}
                        className="ml-3 flex-shrink-0 text-green-600 hover:text-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded-md"
                        aria-label="Close success message"
                    >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
}
